module.exports = __webpack_public_path__ + "static/media/logo-min.d628419b.svg";


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/assets/img/logo-min.svg
// module id = 863
// module chunks = 0